export default __webpack_public_path__ + "static/media/questions-xs.23c27962.webp";